/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React from 'react';
import { styled } from 'styled-components';
import { getContent } from './base-content';
import { baseStyle, colorSets, fontBySize } from './styles';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
export const Button = ({
  ariaLabel,
  colorSet = colorSets.primary,
  expand = false,
  fontType = 'Regular',
  icon,
  iconSize = 24,
  iconIndicator = false,
  isActive = false,
  isDisabled = false,
  leftAligned = false,
  size = 'default',
  fontSize = fontBySize[size],
  ...rest
}) => {
  const text = rest.type === 'text' ? rest.text : undefined;
  return /*#__PURE__*/_jsx(StyledButton, {
    ariaLabel,
    colorSet,
    expand,
    fontType,
    fontSize,
    isActive,
    isDisabled,
    leftAligned,
    size,
    ...rest,
    children: getContent({
      fontType,
      fontSize,
      icon,
      iconColor: colorSet.iconColor,
      iconSize,
      iconIndicator,
      multilineText: rest.multilineText,
      text
    })
  });
};
const StyledButton = styled(({
  ariaLabel,
  ariaPressed,
  children,
  className,
  isDisabled,
  onClick,
  tabIndex
}) => /*#__PURE__*/_jsx("button", {
  "aria-label": ariaLabel,
  "aria-pressed": ariaPressed,
  children: children,
  className: className,
  disabled: isDisabled,
  onClick: onClick,
  tabIndex: tabIndex
})).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1hu80ko-0"
})(["", ";"], baseStyle);
export const PrimaryButton = props => Button({
  colorSet: colorSets.primary,
  ...props
});
export const SecondaryButton = props => Button({
  colorSet: colorSets.secondary,
  ...props
});
export const AlertButton = props => Button({
  colorSet: colorSets.alert,
  ...props
});
export const TransparentButton = props => Button({
  colorSet: colorSets.transparent,
  ...props
});
export const ToggleButton = props => Button({
  colorSet: {
    ...colorSets.toggle,
    hoverIconColor: props.isActive ? Colors.WHITE : Colors.GREY_969696,
    hoverColor: props.isActive ? Colors.WHITE : Colors.GREY_969696
  },
  ariaPressed: props.isActive,
  ...props
});